<!--底部菜单-->
<template>
  <div class="loading">
    <div class="onloading">
      <i class="el-icon-loading"></i>
      <p>加载中</p>
    </div>
  </div>
</template>
<script>

  export default{
    data(){
      return {

      }
    },
    methods:{

    },
    mounted(){
    }

  }
</script>
<style lang="scss" scoped>
.loading{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 60px;
  pointer-events: none;
  z-index: 9999;

  .onloading{
    width: 10rem;
    height: 10rem;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 0.5rem;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .el-icon-loading{
      font-size: 4rem;
      color: rgba(255, 255, 255, 0.81);
      margin-bottom: 10px;
    }
    p{
      color: rgba(255, 255, 255, 0.81);
    }


  }
}

</style>





